import { SvgIcon, SvgIconProps } from '@mui/material';

type Props = SvgIconProps;

const Repeat = ({ sx, ...props }: Props) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" sx={{ stroke: '#667085', fill: 'transparent', ...sx }} {...props}>
      <g clipPath="url(#clip0_4934_59229)">
        <path
          d="M8.5 0.5L10.5 2.5M10.5 2.5L8.5 4.5M10.5 2.5H3.5C2.96957 2.5 2.46086 2.71071 2.08579 3.08579C1.71071 3.46086 1.5 3.96957 1.5 4.5V5.5M3.5 11.5L1.5 9.5M1.5 9.5L3.5 7.5M1.5 9.5H8.5C9.03043 9.5 9.53914 9.28929 9.91421 8.91421C10.2893 8.53914 10.5 8.03043 10.5 7.5V6.5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4934_59229">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
export default Repeat;
